type FormatMessage = (descriptor: { id: string; defaultMessage?: string }, values?: Record<string, string>) => string;

const KNOWN_API_MESSAGES: Record<string, string> = {
    'You do not have permissions to access this resource.': 'NO_TIENE_PERMISOS_PARA_REALIZAR_ESTA_ACCION',
    'Servicio no activo, Para activar este servicio debe contratarlo. Por favor contacte con el equipo de Rubricae.': 'SERVICIO_NO_ACTIVO'
};

/** Claves numéricas → locales; mensajes conocidos → clave i18n; resto → literal. */
export const resolveDisplayErrorMessage = (
    messageOrCode: string,
    messages: Record<string, string>,
    formatMessage: FormatMessage,
    values?: Record<string, string>
): string => {
    const raw = String(messageOrCode || '1000').trim();
    if (messages[raw]) {
        return formatMessage({ id: raw }, values);
    }
    const mappedKey = KNOWN_API_MESSAGES[raw];
    if (mappedKey && messages[mappedKey]) {
        return formatMessage({ id: mappedKey }, values);
    }
    if (/^\d+$/.test(raw)) {
        return formatMessage({ id: raw, defaultMessage: messages['1000'] || raw });
    }
    return raw;
};
